export default {
  init() {
    const $modules = document.querySelectorAll('.ms-value-prop');

    if (!$modules.length) { return; }

    // A11Y fix for Voice-over to read custom-styled list as "lists"
    const isSafari = Boolean(window.navigator.userAgent.match(/Version\/[\d.]+.*Safari/));

    // For Safari Only.
    if (isSafari) {
      $modules.forEach(valueProp => {
        const valuePropList = valueProp.querySelector('.ms-value-prop__list');

        if (!valuePropList) return;

        const listElements = valuePropList.querySelectorAll('ul, ol');

        listElements.forEach(listElem => {
          listElem.setAttribute('role', 'list');

          Array.from(listElem.children).forEach(listItem => {
            listItem.setAttribute('role', 'listitem');
          });
        });
      })
    }

    const targetValueProp = document.querySelector('.ms-value-prop--bullet.ms-value-prop--right');

    if (!targetValueProp) { return; }

    const targetHero = targetValueProp.previousElementSibling;

    // let's check if the target value prop's previous sibling is a Small Hero
    if (targetHero.classList.contains('ms-small-hero')) {
      targetHero.classList.add('ms-small-hero--long');
      targetValueProp.classList.add('ms-value-prop--next-from-hero');

      const editorialDetailHero = targetHero.nextElementSibling;

      if (editorialDetailHero.classList.contains('ms-value-prop')) {
        targetHero.classList.add('ms-small-hero--detail-hero');
      }
    }
  },
}



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/value-prop.js